import { TField } from '$hook-forms/PasswordVerifyForm'
import { TypeSubmitForm } from '$hook-forms/types'

export type UsePasswordVerifyBlockOptions = TypeSubmitForm<TField> & {
  title: string
  description: string
  submitButtonText?: string
}

export const usePasswordVerifyForm = (props: UsePasswordVerifyBlockOptions) =>
  props

export default usePasswordVerifyForm
